import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from './baseQuery';

export interface ShopCategory {
  _id: string;
  name: string;
  created_at: string;
  updated_at: string;
}

export interface CreateShopCategoryDto {
  name: string;
}

export interface UpdateShopCategoryDto {
  name: string;
}

export const shopCategoriesApi = createApi({
  reducerPath: 'shopCategoriesApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['ShopCategories'],
  endpoints: (builder) => ({
    getShopCategories: builder.query<ShopCategory[], void>({
      query: () => '/shop-categories',
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ _id }) => ({ type: 'ShopCategories' as const, id: _id })),
              { type: 'ShopCategories', id: 'LIST' },
            ]
          : [{ type: 'ShopCategories', id: 'LIST' }],
    }),
    getShopCategory: builder.query<ShopCategory, string>({
      query: (id) => `/shop-categories/${id}`,
      providesTags: (_result, _error, id) => [{ type: 'ShopCategories', id }],
    }),
    createShopCategory: builder.mutation<ShopCategory, CreateShopCategoryDto>({
      query: (data) => ({
        url: '/shop-categories',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: [{ type: 'ShopCategories', id: 'LIST' }],
    }),
    updateShopCategory: builder.mutation<ShopCategory, { id: string; category: UpdateShopCategoryDto }>({
      query: ({ id, category }) => ({
        url: `/shop-categories/${id}`,
        method: 'PATCH',
        body: category,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: 'ShopCategories', id },
        { type: 'ShopCategories', id: 'LIST' },
      ],
    }),
    deleteShopCategory: builder.mutation<void, string>({
      query: (id) => ({
        url: `/shop-categories/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_result, _error, id) => [
        { type: 'ShopCategories', id },
        { type: 'ShopCategories', id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useGetShopCategoriesQuery,
  useGetShopCategoryQuery,
  useCreateShopCategoryMutation,
  useUpdateShopCategoryMutation,
  useDeleteShopCategoryMutation,
} = shopCategoriesApi; 